import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Spin, Modal, notification } from 'antd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { green } from '@material-ui/core/colors';
import Highlighter from 'react-highlight-words';
import 'antd/dist/antd.css';

const { Title } = Typography;

@inject(
    'BookingSubCategoryStore'
)
@observer
class BookingSubCategoryListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
        this.props.BookingSubCategoryStore.initBookingSubCategory();
    }

    // ON CLICK

    createBookingSubCategoryOnClick = () => {
        this.props.BookingSubCategoryStore.initCreateBookingSubCategory();
    }

    updateBookingSubCategoryOnClick = (id) => {
        this.props.BookingSubCategoryStore.initUpdateBookingSubCategory(id);
    }

    deleteBookingSubCategoryOnClick = (id) => {
        Modal.confirm({
            title: 'Delete Booking Sub Category',
            content: 'Are you sure to delete this sub category?',
            okText: 'Yes',
            cancelText: 'Cancel',
            onOk: () => { this.deleteUpdateBookingSubCategoryOnOk(id); }
        });
    }

    // ON OK

    deleteUpdateBookingSubCategoryOnOk = (id) => {
        this.props.BookingSubCategoryStore.deleteUpdateBookingSubCategory(id).then(response => {
            if (response.isSuccess) {
                notification['success']({
                    message: 'Success',
                    description: 'Booking Sub Category has been successfully updated.',
                    duration: 3
                });
            } else {
                notification['error']({
                    message: 'Error',
                    description: `${response.error}`,
                    duration: 3
                });
            }
        });
    }

    // TABLE SETTING

    getColumns = () => {
        return [
            {
                title: 'Category',
                dataIndex: 'bookingCategoryName',
                key: 'bookingCategoryName',
                ...this.getColumnSearchProps('bookingCategoryName')
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                ...this.getColumnSearchProps('name')
            },
            {
                title: 'Capacity',
                dataIndex: 'capacity',
                key: 'capacity',
                ...this.getColumnSearchProps('capacity')
            },
            {
                title: 'Max Hour Per Day',
                dataIndex: 'maxHourPerDay',
                key: 'maxHourPerDay',
                ...this.getColumnSearchProps('maxHourPerDay')
            },
            {
                title: 'Sort Order',
                dataIndex: 'sortOrder',
                key: 'sortOrder',
                ...this.getColumnSearchProps('sortOrder')
            },
            {
                title: 'Is Available',
                dataIndex: 'isAvailable',
                key: 'isAvailable',
                render: isAvailable => (
                    <span>{isAvailable ? 'Yes' : 'No'}</span>
                )
            },
            {
                title: 'Action',
                dataIndex: 'id',
                key: 'id',
                render: id => (
                    <span>
                        <Button onClick={() => this.updateBookingSubCategoryOnClick(id)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteBookingSubCategoryOnClick(id)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const {
            bookingSubCategories,
            bookingSubCategoryListLoading
        } = this.props.BookingSubCategoryStore;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3} style={{ width: '80%', position: 'relative', float: 'left' }}>List</Title>
                        <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={this.createBookingSubCategoryOnClick}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Spin spinning={bookingSubCategoryListLoading}>
                        <Table columns={this.getColumns()} dataSource={bookingSubCategories} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default BookingSubCategoryListPage;
